import Agent from '.';

class Timer {
  agent: Agent;
  MAX_IDLE_TIME: number;
  timeoutId: number;

  constructor(agent: Agent, MAX_IDLE_TIME: number) {
    this.agent = agent;
    this.MAX_IDLE_TIME = MAX_IDLE_TIME;
    this.timeoutId = 0;
  }

  restart() {
    this.stop();
    this.start();
  }

  stop() {
    clearTimeout(this.timeoutId);
  }

  start() {
    this.timeoutId = window.setTimeout(
      this.agent.handleTimeout.bind(this.agent),
      this.MAX_IDLE_TIME
    );
  }
}

export default Timer;
